import { REDIRECT_ROUTE } from '../constants/actionTypes';

const INITIAL_STATE = {
  route: null,
};

const applyRedirectRoute = (state, action) => ({
  ...state,
  route: action.route,
});

const routeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case REDIRECT_ROUTE:
      return applyRedirectRoute(state, action);
    default:
      return state;
  }
};

export default routeReducer;
